module.exports = __webpack_public_path__ + "img/signature.7bba999f.png";